module.exports = __webpack_public_path__ + "lock.32db7b5a.svg";